import classNames from "classnames";
import { AppNavLink } from "@/shared/Components";
import type { FC } from "react";
import type { NavLinkProps } from "react-router-dom";
import styles from "./styles.module.scss";

type Props = NavLinkProps & {
  title: string;
  icon: JSX.Element;
};

export const MenuListItem: FC<Props> = ({ title, icon, ...props }) => {
  return (
    <AppNavLink className={styles["link-container"]} {...props}>
      {({ isActive }) => {
        return (
          <div className={classNames(styles.link, { [styles.active]: isActive })}>
            {icon}
            {title}
          </div>
        );
      }}
    </AppNavLink>
  );
};
